import React from 'react';
import ReactDOM from 'react-dom';
import {
    GoogleReCaptchaProvider,
  } from 'react-google-recaptcha-v3';
import App from './App';
import reportWebVitals from './reportWebVitals';

import './locales';

import './style.css';

import ThemeProvider from './theme/ThemeProvider';
import { applyResolvedTheme } from './theme/tokens';

// Prevent flash of wrong theme before React mounts
applyResolvedTheme();

ReactDOM.render(
    <ThemeProvider>
      <GoogleReCaptchaProvider language='en' reCaptchaKey="6LcJR7srAAAAANTB_DjENsrxlojKD4gHh9a9BbCn">
        <App />
      </GoogleReCaptchaProvider>
    </ThemeProvider>,
    document.getElementById('root')
  );
// ReactDOM.render(, document.getElementById('root'));

reportWebVitals();
